// Autogenerated file
export const transportationFormatsEnum = {
    OwnFleet: "OwnFleet",
    OwnFleetAndForwarding: "OwnFleetAndForwarding",
    Forwarding: "Forwarding",
    Other: "Other",
};
export const transportationFormats = [
    { label: "Собственный парк", value: "OwnFleet" },
    { label: "Собственный парк + экспедирование", value: "OwnFleetAndForwarding" },
    { label: "Экспедирование", value: "Forwarding" },
    { label: "Другое", value: "Other" },
];
